// extracted by mini-css-extract-plugin
module.exports = {"carousel":"markdown-carousel_carousel__wlGTK"};